export const DELIVERY_CHARGE_FUNCTION = 'DELIVERY_CHARGE_FUNCTION';
export const onCheckoutRegion = (deliverycharge, deliveryType) => async (dispatch) => {
  if (deliveryType === 'delivery') {
    return dispatch({ type: DELIVERY_CHARGE_FUNCTION, deliverycharge: deliverycharge });
  } else {
    return dispatch({ type: DELIVERY_CHARGE_FUNCTION, deliverycharge: 0 });
  }
};
